import { render } from "./EventReportView.vue?vue&type=template&id=32759b96"
import script from "./EventReportView.vue?vue&type=script&lang=js"
export * from "./EventReportView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__